import styled from 'styled-components';
import { LazyGameIcon } from '@/shared/ui/lazy-game-icon';
import { brandIsPh, brandIsPh2 } from '@/shared/config/brand-by-target.mjs';

export const SectionContent = styled.div`
  position: absolute;
  z-index: 10;
  display: none;
  width: 100%;
  height: 100%;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const SectionTitle = styled.div`
  color: #edeff5;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
`;

export const DisabledOverlay = styled.div<{
  $isHovered: boolean;
  $disabledGame: boolean;
}>`
  position: absolute;
  width: 100%;
  z-index: 10;
  text-align: left;
  left: 0;
  pointer-events: none;
  background: linear-gradient(180deg, #131315 0%, rgba(19, 19, 21, 0) 100%);
  padding: 12px 8px;

  ${({ $isHovered }) =>
    $isHovered &&
    `
      background: #DA4444;
      z-index: 101;
      top: 10px;
      padding: 2px 8px;
    `}

  ${({ $disabledGame }) =>
    !$disabledGame &&
    `
      display: none;
    `}
`;

export const Section = styled.div<{
  $isActive: boolean;
  $hasScroll: boolean;
  $disabledGame: boolean;
}>`
  grid-column-end: span 1;
  grid-row-end: span 1;
  width: 100%;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: auto;
  aspect-ratio: 3/4;

  ${({ $isActive }) =>
    $isActive &&
    `
    border-radius: '8px' ;
    border:2px solid #FF9F0A;
  `}

  ${({ $hasScroll }) =>
    $hasScroll &&
    `
    @media (max-width: 768px) {
      width: 114px;
      height: 152px;
      flex-grow: 0;
      flex-shrink: 0;
    }
  `}

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        background:
          url(/images/background/hover-game.svg),
          linear-gradient(90deg, #ff9500 0%, #ff5e00 100%) #ff9500;
        background-position: center center;
        animation: 10s linear 0s infinite normal none running rotate;
        inset: -50%;
        background-blend-mode: overlay;
        z-index: 5;
      }

      & > ${SectionContent} {
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 15;
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ImageElement = styled(LazyGameIcon)`
  padding: 1px;
  border-radius: 8px;
  object-fit: cover;
  position: relative;
  color: #fff;
  z-index: 1;
  cursor: pointer;
`;

export const SectionDescription = styled.div`
  color: #ffda44;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

export const SectionButton = styled.div`
  border-radius: 8px;
  background: #edeff5;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  margin: 0 28px;
  margin-top: 14px;
  color: #161639;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
  text-align: center;
  padding: 12px 12px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const ImageBonus = styled.div<{ $hasBonus: boolean }>`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-size: contain;
  ${({ $hasBonus }) =>
    $hasBonus &&
    `
    background-image: url(/images/icons/gift-game.svg);
  `}
`;

export const InfoPseudoButton = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(/images/icons/info-empty.svg);

  &:hover {
    background-image: url(/images/icons/info-filled.svg);
  }
`;
export const CardFooter = styled.div`
  position: absolute;
  bottom: 16px;
  width: 100%;
`;

export const CardFooterRow = styled.div`
  display: flex;
  justify-content: ${!brandIsPh || brandIsPh2 ? 'space-between' : 'flex-end'};
  align-items: center;
  padding: 0 12px;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 6px;
`;

export const WishlistSlot = styled.div`
  display: block;
`;
